{
	"id": 7501,
	"moduleNumber": 1,
	"slug": "module-1",
	"kgNodeId": "module-1",
	"title": "Professional Ethics for Educators",
	"subtitle": "Learn the ethical framework, PROETHICS principles, and how to apply them.",
	"type": "lesson",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "module_list_only",
	"summary": "Module 1 introduces professional ethics for educators, the ethical framework used throughout ProEthica, and the ProEthics principles learners will apply in later scenario-based modules.",
	"estimatedDurationMinutes": 25,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": false,
		"questionCount": 0
	},
	"learningObjectives": [
		"Recognize the purpose of professional ethics for educators.",
		"Identify the ethical framework and ProEthics principles used across the course.",
		"Prepare to apply the framework in scenario-based ethical decision making."
	],
	"flow": [
		"Introduction to professional ethics for educators.",
		"Scenario video.",
		"Ethical framework.",
		"ProEthics principles.",
		"Pretest covering course modules."
	],
	"scenarios": [
		{
			"id": "module-1-introduction",
			"title": "Introduction: Professional Ethics for Educators",
			"summary": "Introduces the course's ethical framework and the principles used to analyze educator decisions."
		}
	],
	"ethicalSituations": [],
	"sources": {
		"moduleList": "../../../../.working/Praxis ProEthics/Content/ProEthica Module List/ProEthica 2.0_Complete Module List.docx",
		"primary": null,
		"scorm": null,
		"transcripts": [],
		"videos": []
	}
}
